<template>
  <div>
    <nav class="bar bar-nav">
      <router-link class="button button-link button-nav pull-left" :to="{ name: 'orderContent', query: {order:order}}">
        <span class="icon icon-left"></span>返回
      </router-link>
    </nav>
    <div class="content">
      <div class="list-block">
        <!--<div class="check-step">-->
          <!--<ul>-->
            <!--<li style="list-style-type:none">地址确认</li>-->
            <!--<li class="cur">产品信息</li>-->
            <!--<li style="list-style-type:none">支付方式</li>-->
            <!--&lt;!&ndash;<li style="list-style-type:none">订单确认</li>&ndash;&gt;-->
          <!--</ul>-->
        <!--</div>-->

        <div class="content">
          <div class="checkout-title">
            <span>商品详细信息</span>
          </div>

          <div class="list-block" style="margin-top: 2px; margin-bottom: 15px;" v-for="me in merchandises">
            <ul>
              <li>
                <div class="item-content">
                  <div class="item-media"><i class="icon icon-form-comment"></i></div>
                  <div class="item-inner">
                    <div class="item-title label">单价</div>
                    <div class="item-input">
                      <span>{{me.unitPrice}}</span>
                    </div>
                  </div>
                </div>
              </li>

              <li>
                <div class="item-content">
                  <div class="item-media"><i class="icon icon-form-comment"></i></div>
                  <div class="item-inner">
                    <div class="item-title label">最小价格</div>
                    <div class="item-input">
                      <span>最小</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="content-block">
            <router-link :to="{name : 'home'}" class="button button-big button-fill button-danger">返回首页</router-link></div>
        </div>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        merchandises: this.$route.query.order.merchandises,
        order: this.$route.query.order
      }
    },
    methods: {
    }
  }
</script>

<style type="text/css" scoped>
</style>



// WEBPACK FOOTER //
// OrderContentDetail.vue?ce673ec0